import { type SVGProps } from "react";

const XingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width ?? 20}
    height={props.height ?? 20}
    fill="currentColor"
    {...props}
  >
    <path d="M4.44 6.56h2.75l3.18 5.56-4.95 8.72H2.66l4.95-8.72z" />
    <path d="M18.34 2h-2.76l-6.22 11 3.95 7.23h2.76l-3.95-7.23z" />
  </svg>
);

export default XingIcon;
